module.exports = __webpack_public_path__ + "img/happy 1-4.f8aebf54.png";